import { DatePicker, Form, FormItem, Input, Textarea } from '@ethsign/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { debounce } from 'lodash-es';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as z from 'zod';

import { IField, InputType } from '@/types';
import { dateFormat } from '@/utils';
const getFormComponent = (item: IField) => {
  switch (item.inputType) {
    case 'textarea':
      return <Textarea placeholder="" />;
    case 'date':
      return <DatePicker className="w-full" format={'DD/MM/YY'} autoHidden placeholder="" />;
    case 'number':
      return <Input type="number" placeholder="" />;
    case 'text':
    default:
      return <Input placeholder="" />;
  }
};
const handleValue = (value: any, inputType: InputType) => {
  switch (inputType) {
    case InputType.textarea:
      return value.replaceAll('<br/>', '\n');
    default:
      return value;
  }
};
export const EditTermsForm = forwardRef<
  { form: UseFormReturn<any, any, any> },
  { data?: IField[]; onChange?: (data: { id: string; value: string }) => void; onFieldClick?: (item: IField) => void }
>(function EditTermsForm({ data, onChange, onFieldClick }, ref) {
  const schemaObj: any = {};
  const defaultValues: any = {};
  data?.forEach((item) => {
    if (item.required) schemaObj[item.id] = z.string();
    defaultValues[item.id] = handleValue(item.value, item.inputType);
  });

  const formSchema = z.object(schemaObj);
  const form = useForm<z.infer<any>>({
    resolver: zodResolver(formSchema),
    defaultValues
  });

  useImperativeHandle(ref, () => ({
    form: form
  }));
  useEffect(() => {
    const subscription = form.watch((value, { name, type }: any) => {
      if (type === 'change') {
        const inputType = data?.find((item) => item.id === name)?.inputType;
        let resValue = value[name];
        switch (inputType) {
          case InputType.date:
            resValue = dateFormat(value[name], 'YYYY-MM-DD');
            break;
          case InputType.textarea:
            resValue = resValue.replace(/\n/g, '<br/>');
            break;
          default:
            break;
        }
        console.log(resValue);

        dataChange({
          id: name,
          value: resValue
        });
      }
    });
    return () => subscription.unsubscribe();
  }, [form.watch, data]);
  const dataChange = debounce((item) => {
    onChange && onChange(item);
  }, 300);

  return (
    <Form form={form} className="space-y-[24px]">
      {data?.map((item: IField, i: number) => (
        <FormItem
          key={i}
          name={item.id}
          label={
            <span onClick={() => onFieldClick && onFieldClick(item)}>
              {(item.label || `Term ${i}`) + (item.required ? ' *' : '')}
            </span>
          }
        >
          {getFormComponent(item)}
        </FormItem>
      ))}
    </Form>
  );
});
